import React, { useState, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Alert,
  Spinner,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./index.scss";
import loginImage from "../../../assets/images/login.png";
import { useAuth } from "../../../adminCompenents/authProvider";

const TwoStepVerification = () => {
  const [code, setCode] = useState(Array(4).fill("")); // 4 cases
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({ hasError: false, msg: "" });
  const inputsRef = useRef([]);
  const navigate = useNavigate();
  const { handelLogin } = useAuth();
  // Gérer la saisie
  const handleChange = (e, index) => {
    const { value } = e.target;
    if (/^[0-9]?$/.test(value)) {
      const newCode = [...code];
      newCode[index] = value;
      setCode(newCode);

      // focus auto
      if (value && index < code.length - 1) {
        inputsRef.current[index + 1].focus();
      }
    }
  };

  // Gérer backspace
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !code[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  // Soumission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({ hasError: false, msg: "" });

    try {
      const userID = localStorage.getItem("userLoginRequestID");
      const codeValue = code.join("");

      if (!userID) {
        setErrors({
          hasError: true,
          msg: "Un problème est survenu, veuillez essayer de vous reconnecter !",
        });
        return;
      }

      if (codeValue.length !== 4) {
        setErrors({
          hasError: true,
          msg: "Le code doit contenir exactement 4 chiffres !",
        });
        return;
      }

      const res = await handelLogin(userID, codeValue);

      if (res.success) {
        navigate("/dashboard");
      } else {
        setErrors({
          hasError: true,
          msg: res.msg || "Échec de la vérification du code !",
        });
      }
    } catch (error) {
      setErrors({
        hasError: true,
        msg: "Erreur serveur. Veuillez réessayer plus tard.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="login-page">
      <Row className="vh-100">
        <Col
          md={6}
          className="d-flex align-items-center justify-content-center">
          <div className="login-box">
            <h2 className="title">Vérification en deux étapes</h2>
            <p className="subtitle">
              Un code de vérification a été envoyé à votre adresse email.
              Veuillez le saisir ci-dessous.
            </p>

            {errors.hasError && <Alert variant="danger">{errors.msg}</Alert>}

            <Form onSubmit={handleSubmit}>
              <div className="code-inputs d-flex justify-content-center mb-4">
                {code.map((digit, index) => (
                  <Form.Control
                    key={index}
                    type="text"
                    value={digit}
                    maxLength="1"
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    ref={(el) => (inputsRef.current[index] = el)}
                    className="code-box mx-1 text-center"
                  />
                ))}
              </div>

              <Button
                type="submit"
                className="btn-verify w-100"
                disabled={loading}>
                {loading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  "Vérifier mon compte"
                )}
              </Button>
            </Form>
          </div>
        </Col>

        <Col
          md={6}
          className="d-none d-md-flex align-items-center justify-content-center right-side">
          <div className="text-center">
            <img
              src={loginImage}
              alt="Illustration de connexion"
              className="login-illustration img-fluid"
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default TwoStepVerification;
